import { VendorRequestStatus } from '../VendorRequestStatusLabel/VendorRequestStatusLabel.constants';

export const VENDOR_REQUEST_STATUS_OPTIONS = Object.values(VendorRequestStatus).map(value => ({
  id: value,
  name: value,
}));
